// extracted by mini-css-extract-plugin
module.exports = {"globalNotificationContainer":"style_globalNotificationContainer__2ad7R","notification":"style_notification__36M11"};